import React, { useState, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
	setState
} from "../analyzeSlice";

const MultiSelectProducts = (props) => {
  const dispatch = useDispatch();
  const skuPgs = props?.skuPgs;
  let products = skuPgs?.map((item) => item.packGroupOrSKUName)
  products = products.filter(item => item !== "All");
  const [productName, setproductName] = useState([]);
  const [displayItem, setDisplayItem] = React.useState(skuPgs.length - 1);
  const [searchText, setSearchText] = React.useState("");
  const [namesData, setNamesData] = React.useState([]);
  const textInput = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const state = useSelector((store) => store.analyze);

  const {
		selectedproducts,
    clearDataValues,
	} = state;

  const handleChange = (e, name) => {
    let items = [...productName];
 
    if (e.target.checked) items.push(name);
    else {
      var index = items.indexOf(name);
      items.splice(index, 1);
    }
    setproductName(items);
    let itemcount = items.length;
    setDisplayItem(itemcount);
    if (itemcount == 0) {
      setSelectAll(false);
    }
    if (itemcount == products.length) {
      setSelectAll(true);
    }
    else {
      setSelectAll(false);
    }
  };

  useEffect(() => {
    // Clear search text value
    setNamesData(products);
  }, [skuPgs]);

  // const handleDelete = (e, value) => {
  //   e.preventDefault();
  //   setSelectAll(false);
  //   setproductName(productName.filter((name) => name !== value));
  // };
  const handleDelete = (e) => {
    e.preventDefault();
    setproductName([]);
    setSelectAll(false);
  };

  const handleInputChange = (value) => {
    setSearchText(value);
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);

    if (!selectAll) {
      if(searchText){
          let val = products.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
          let item = [...productName, ...val];
          const distinctArray = [...new Set(item)];
          setproductName(distinctArray);
          let itemcount = distinctArray.length-1;
          setDisplayItem(itemcount);
      }else{
          setproductName(products);
          let itemcount = products.length-1;
          setDisplayItem(itemcount);
      }
  } else {
      if(searchText){
          let val = products.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
          let item = [...productName];
          item = item.filter((name) => !val.includes(name));
          const distinctArray = [...new Set(item)];
          setproductName(distinctArray);
          let itemcount = distinctArray.length;
          setDisplayItem(itemcount);
      }else{
          setproductName([]);
          let itemcount = 0;
          setDisplayItem(itemcount);
      }
    }
  };

  useEffect(() => {
    let itemcount = selectedOptions.length - 1;
    setDisplayItem(itemcount);
  }, [selectedOptions])

  useEffect(() => {
    let itemcount = productName.length - 1;
    setDisplayItem(itemcount);
  }, [productName])

  
  // useEffect(() => {
  //   if(selectAll){
  //   let itemcount = namesData.length - 1;
  //   setDisplayItem(itemcount);
  //   setproductName(products);
  //   }
  //   else if(!selectAll && productName.length === products.length){
  //     setproductName(prev => prev);
  //   }
  //   else if(!selectAll && productName.length < products.length){
  //     setproductName(prev => prev);
  //   }
  //   else{
  //     setproductName([]);
  //   }
  // }, [selectAll])

  useEffect(() => {
    let item = [...namesData];
    item = item.filter((name) => !productName.includes(name));
    if(item.length == 0){
        setSelectAll(true);
    }else{
        setSelectAll(false);
    }
  }, [namesData]);

  useEffect(() => {
    //use a debounce to delay the search input key entry
    const delayDebounceFn = setTimeout(() => {
      if (searchText) {
        //filter options state using search text provided
        setNamesData((prevVal) => {
          let val = products.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));

          return val;
        });
      } else {
        setSearchText();
        setNamesData(products);
      }

      //set focus on search text input field on load. setTimeOut is added as textInput is not immediately available
      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  const getProductIdsFromNames = (productNames) => {
    const productIds = productNames.map((name) => {
      const product = skuPgs.find((option) => option.packGroupOrSKUName === name);
      return product ? product.packGroupOrSKUID : null;
    });
    return productIds.filter((id) => id !== null);
  };

  useEffect(() => {
      if(productName.length > 0){
        dispatch(setState("selectedDataProductIds", getProductIdsFromNames(productName)));
        dispatch(setState("clearDataValues", false));
      }
      else{
        dispatch(setState("selectedDataProductIds", []))
      }
  }, [productName])

  useEffect(() => {
    if (clearDataValues) {
      setproductName([]);
      setSelectAll(false);
    }
  }, [clearDataValues])

  return (
    <div>
      <FormControl>
      <InputLabel>SKU / PG</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          fullWidth
          sx={{
            width: "250px !important",
            height: "44px !important",
          }}
          value={productName}
          //onChange={handleChange}
          size="small"
          input={<OutlinedInput label="MultiSelect" />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }} MenuProps>
                 <div>
                 {productName.length === 1 &&(
                    <span>{productName[0]?.substring(0, 15)}</span>
                    )}
                    {productName.length > 1 && (
                      <span>{productName[0]?.substring(0, 15)} +  <b>{displayItem}</b></span>
                  )}
                 <span>
                   <CancelIcon
                     sx={{
                       paddingLeft: "25px",
                       top: "20%",
                       position: "absolute",
                     }}
                     onMouseDown={(e) => {
                       e.stopPropagation();
                       e.preventDefault();
                     }}
                     onClick={(e) => handleDelete(e)}
                   />
                 </span>
               </div>
            </Box>
          )}
        >
          <MenuItem onClick={handleSelectAll}>
            <Checkbox checked={selectAll} />
            <ListItemText primary="Select All" />
          </MenuItem>
          <ListSubheader>
            <TextField
              size="small"
              inputRef={textInput}
              placeholder=""
              //fullWidth
              value={searchText}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  /*close icon to clear the search text*/
                  <InputAdornment position="end">
                    <IconButton onClick={() => setSearchText("")}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleInputChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {namesData?.map((name, index) => (
            <MenuItem key={index + name} value={name}>
              {selectAll ? <Checkbox  onChange={(e) => handleChange(e, name)}
                checked={productName.some((o) => o === name)}
              /> :
                <Checkbox  onChange={(e) => handleChange(e, name)}
                checked={productName.indexOf(name) > -1} />}
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default MultiSelectProducts